<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailMateriel.collectivite.title') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.collectivite.declarableMairie')"
                 custom-class="has-text-link mgb-5px">
          {{ materiel.declarableEnMairie ? $t('general.oui') : $t('general.non') }}
        </b-field>
      </div>
      <div class="column is-5">
        <b-field :label="$t('detailMateriel.collectivite.collectiviteInput')"
                 custom-class="has-text-link mgb-5px">
          <b-field>
          <router-link-blank
            :to="{ name: 'c.gabed.collectivite', params: { id: materiel.collectiviteId }}"
            class="lien"
            :message="materiel.collectivite ? materiel.collectivite.nomCommercial: ''">
          </router-link-blank>
            <span>{{ materiel.collectiviteId
              ? getFormattageCollectivite(materiel.collectivite) : null }}</span>
          </b-field>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('detailMateriel.descriptionTlpe')"
            custom-class="has-text-link mgb-5px">
            <p>{{ $t(getLibelleDescriptionTlpe(materiel.descriptionTlpe))}}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.collectivite.etatMontageTlpe')"
            custom-class="has-text-link mgb-5px">
            <p>{{ $t(getLibelleEtat(materiel.etatMontageTlpe))}}</p>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('detailMateriel.collectivite.etatDemontagelpe')"
            custom-class="has-text-link mgb-5px">
            <p>{{ $t(getLibelleEtat(materiel.etatDemontageTlpe))}}</p>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { get } from '@/api/tiers';
import messageErreur from '@/services/general/messageErreur';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { LISTE_ETAT_FIL_DE_LEAU } from '@/configuration/gabed/materiel/materielConf';
import { LISTE_DESCRIPTION_TLPE } from '@/configuration/gabed/tlpe/tlpeConf';

export default {
  name: 'MaterielDetailCollectivite',
  props: {
    materiel: {
      type: Object,
      reuired: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      libelleCollectivite: null,
      LISTE_DESCRIPTION_TLPE,
      LISTE_ETAT_FIL_DE_LEAU,
    };
  },
  methods: {
    getFormattageCollectivite(collectivite) {
      let libelle = '';
      if (adressFullStringGetter(collectivite.adressePostale, false) !== '') {
        libelle += ' - ' + adressFullStringGetter(collectivite.adressePostale, false);
      }
      if (collectivite.compteComptable) {
        libelle += ' - ' + collectivite.compteComptable;
      }
      return libelle;
    },
    getLibelleDescriptionTlpe(descriptionTlpe) {
      const descriptionFind = this.LISTE_DESCRIPTION_TLPE
        .find(el => el.code === descriptionTlpe);
      return descriptionFind ? descriptionFind.libelle : '';
    },
    getLibelleEtat(etat) {
      const etatFind = this.LISTE_ETAT_FIL_DE_LEAU
        .find(el => el.code === etat);
      return etatFind ? etatFind.libelle : '';
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.materiel.collectiviteId) {
        this.materiel.collectivite = (await get(this.materiel.collectiviteId)).data.result;
        this.libelleCollectivite = this.materiel.collectiviteId
          ? this.getFormattageCollectivite(this.materiel.collectivite) : null;
      }
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
